import { Logo } from '@/components/common/Logo';
import { AdminLoginForm } from '../components/AdminLoginForm';

export function AdminLoginPage() {
  return (
    <div className="from-primary-50 to-brand-50 relative min-h-screen bg-gradient-to-br via-white dark:from-neutral-950 dark:via-neutral-900 dark:to-neutral-950">
      <div className="flex min-h-screen justify-center">
        {/* Form side */}
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:w-1/2 lg:flex-none lg:px-8">
          <div className="mx-auto w-full max-w-md">
            {/* Logo */}
            <div className="mb-0 text-center">
              <Logo height={120} width={120} className="justify-center" />
            </div>

            {/* Header */}
            <div className="mb-8 text-center">
              <h2 className="text-3xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">
                Connexion Admin
              </h2>
              <p className="mt-2 text-neutral-600 dark:text-neutral-400">
                Backoffice d'administration Innov' Paie
              </p>
            </div>

            {/* Form Card */}
            <div className="shadow-soft rounded-2xl border border-neutral-200 bg-white p-8 dark:border-neutral-800 dark:bg-neutral-900/90 dark:shadow-hard">
              <AdminLoginForm />
            </div>

            {/* Footer */}
            <div className="mt-8 text-center">
              <p className="text-xs text-neutral-500">
                &copy; {new Date().getFullYear()} Innov' Paie — Tous droits réservés
              </p>
              <p className="mt-1 text-xs text-neutral-400">
                Accès réservé aux administrateurs
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
